import { scrollToId } from "@/lib/smoothScroll";

const NAV = [
  { label: "Product", id: "product" },
  { label: "Pricing", id: "pricing" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-hairline bg-bg-primary/75 py-14 backdrop-blur-md">
      <div className="container-max band-pad">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="flex items-center gap-2.5">
            <span className="grid h-8 w-8 place-items-center overflow-hidden rounded-lg ring-1 ring-signal/30">
              <img src="/logo.webp" alt="RelayOps" className="h-full w-full object-cover" />
            </span>
            <span className="font-display text-lg font-semibold tracking-tight text-ink">
              Relay<span className="text-signal">Ops</span>
            </span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollToId(n.id)}
                className="font-sans text-sm text-ink-muted transition-colors hover:text-ink"
              >
                {n.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-hairline pt-6 font-mono text-[11px] text-ink-muted sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} RelayOps, Inc. · Chicago, IL</span>
          <span className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-signal" />
            all systems operational · SLA 94%
          </span>
        </div>
      </div>
    </footer>
  );
}
